import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BB_ROLE_IDS, LLTTF_ROLE_IDS } from 'src/app/components/authorize/admin-program-mode';
import { Provinces } from 'src/app/components/global/province';
import { CreateUser, createuserdefaultvalues } from 'src/app/components/users/createuser';
import { AuthService } from 'src/app/services/auth.service';
import { BranchService } from 'src/app/services/branch.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { ProvinceService } from 'src/app/services/province.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss'],
    standalone: false
})
export class CreateUserComponent {


  createuserobj:CreateUser=createuserdefaultvalues();
  selectedRolesBB:any[]=[];
  selectedRolesLLTTF:any[]=[];
  selectedRoles:any[]=[]
  applicationRoles:any[]=[];
  provinces:any[]=[]
  branches:any[]=[]
  filteredBranchs:any[]=[]
  orgs:any[]=[]
  filteredOrgs:any[]=[]
  showbranch:boolean=false;
  showorg:boolean=false;
  isCreating = false;
  /** DevAdmin only: optional password when creating a user. */
  canSetPassword = false;
  pageName = CheckPageAccess.ADDUSER

  get showBranchSection(): boolean {
    return this.showbranch && this.createuserobj.province !== Provinces.Ontario;
  }

  constructor(private _userservice:UserService,private _toast:ToastService,private router:Router,private orgservice:OrganizationService,private provinceservice:ProvinceService,
    private branchservice:BranchService,
    private _authservice: AuthService
  ){}
  ngOnInit(){
    this.canSetPassword = !!this._authservice.getAccessControl().canEditEmail;

    this._userservice.getApplicationRolesForAddUser().subscribe({
      next:(roles) =>{
        let roleList = roles.roles || [];
        const mode = this._authservice.getEffectiveProgramMode();
        const roleIds = mode === 'llttf' ? LLTTF_ROLE_IDS : BB_ROLE_IDS;
        roleList = roleList.filter((r: any) => roleIds.includes(r.id));

        if (mode === 'llttf') {
          this.showbranch = false;
          this.showorg = true;
        } else {
          this.showbranch = !!roles.showBranch;
          this.showorg = false;
        }
        this.applicationRoles = roleList;
        }
    })

    this.provinceservice.getProvinces().subscribe({
      next:(provinces) =>
        {
          this.provinces=provinces
        }
    });

    this.branchservice.getBranches().subscribe({
      next:(branches) =>
      {
        this.branches=branches
      }
    });

    this.orgservice.getOrganizationForUser().subscribe({
      next:(orgs) =>
      {
        this.orgs = orgs;
      }
    });


  }

  createUser(_t54: NgForm) {
    if (this.isCreating) {
      return;
    }
    if (_t54.invalid) {
      Object.values(_t54.controls).forEach(control => control.markAllAsTouched());
      return;
    }
    if (!this.canSetPassword) {
      this.createuserobj.password = '';
    } else if (this.createuserobj.password?.trim()) {
      const passwordError = this.validateOptionalPassword(this.createuserobj.password);
      if (passwordError) {
        this._toast.showErrorMessage(passwordError);
        return;
      }
    } else {
      this.createuserobj.password = '';
    }
    this.createuserobj.applicationRoles = this.selectedRoles;
    this.isCreating = true;
    this._userservice.createUser(this.createuserobj).subscribe({
      next: (res) => {
        this.isCreating = false;
        if (res.status) {
          this._toast.showMessage("User Created successfully");
          this.router.navigateByUrl("/user-list");
        } else {
          this._toast.showMessage("Email already exists");
        }
      },
      error: () => {
        this.isCreating = false;
        this._toast.showErrorMessage("Failed to create user. Please try again.");
      }
    });
  }

  isItemChecked(role: any, selectedRoles: number[]): boolean {
    return selectedRoles.includes(role.id);
  }

  onBBCheckboxChange(role: any): void {
    const index = this.selectedRolesBB.indexOf(role.id);
    if (index === -1) {
      this.selectedRolesBB.push(role.id);
    } else {
      this.selectedRolesBB.splice(index, 1);
    }
  }
	

  onLLTTFCheckboxChange(role: any): void {
    const index = this.selectedRolesLLTTF.indexOf(role.id);
    if (index === -1) {
      this.selectedRolesLLTTF.push(role.id);
    } else {
      this.selectedRolesLLTTF.splice(index, 1);
    }
    }

  
    isBBDisabled(): boolean {
    return this.selectedRolesLLTTF.length > 0;
  }

  // Method to determine if LLTTF checkboxes should be disabled
  isLLTTFDisabled(): boolean {
    return this.selectedRolesBB.length > 0;
  }

  bindBranches()
  {   
    if (this.createuserobj.province === Provinces.Ontario) {
      this.filteredBranchs = [];
      this.createuserobj.branch = 0;
    } else {
      this.filteredBranchs = this.branches.filter(b=>b.provinceId == this.createuserobj.province);
    }
    this.filteredOrgs = this.orgs.filter(o=>o.provinceId == this.createuserobj.province)
    
  }

  private validateOptionalPassword(password: string): string | null {
    if (password.length < 10) {
      return 'Password must be at least 10 characters.';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Password must contain at least one uppercase letter.';
    }
    if (!/[a-z]/.test(password)) {
      return 'Password must contain at least one lowercase letter.';
    }
    if (!/[0-9]/.test(password)) {
      return 'Password must contain at least one number.';
    }
    return null;
  }

}
